export const redirect = (href: string) => window.location.assign(href);

export function reload(): void {
  window.location.reload();
}

/**
 * Returns the URL Search params from location hash string
 */
export function getURLSearchParameters(): URLSearchParams {
  if (!window.location.hash) {
    return new URLSearchParams();
  }

  const [, searchString] = window.location.hash.split('?');
  return new URLSearchParams(searchString);
}

export const getBaseDashboardUrl = (): string => {
  if (process.env.NODE_ENV === 'development' && !__IS_TEST__) {
    return window.location.origin;
  }

  return configurationURL.angularDashboard.baseUrl;
};
